/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ErrorCodes {
    Unknown = 0,
    IdNotFound = 100,
    IncorrectState = 101,
    SaveDbObjectError = 102,
    IncorrectType = 103,
    RoomsInUseError = 1000,
    MemberTypeNotAllowed = 2000,
    SessionOutsideEventError = 3000,
    SessionDateIsInPastError = 3100,
    AudioServerNotResponding = 4000,
    RecordingServerNotResponding = 5000,
}
